import { ABTestExperimentConfig } from '@jusbrasil-web/shared-ab-test'

export const DEFAULT_EXPERIMENTS = [
  {
    experimentGroup: 'docview',
    experimentName: 'seus-direitos-sofia-2',
    controlKey: 'control',
  },
]

export const getActiveExperiments = (): ABTestExperimentConfig[] => {
  return DEFAULT_EXPERIMENTS
}
